import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxComponent } from './checkbox.component';
import { CheckboxRoutingModule } from './checkbox-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {CheckboxModule} from "../../component/ing/checkbox/checkbox";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CheckboxRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    CheckboxModule,
    TableModule
  ],
  declarations: [CheckboxComponent]
})
export class CheckboxDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/checkbox/checkboxDemo.module.ts